export const ENTITY_NAME = 'EntityName';
export const ENTITY_ALIAS = 'EntityAlias';
export const OBJECT_KEY = 'ObjectKey';
export const LINK_SOURCE = 'LinkSource';
export const LINK_TARGET = 'LinkTarget';
export const FILTER = 'Filter';

export const DATA_MODEL_TAB = 'Data Model';

export const HEADER_ITEM_DEFAULT_LABEL = '---';

export const DEFAULT_DESIGN_PANEL_WIDTH = 450;
export const MAX_DESIGN_PANEL_WIDTH = 600;
export const MIN_DESIGN_PANEL_WIDTH = 450;

export const DEFAULT_ENTITY_NAME_WIDTH = 270;
export const ENTITY_NAME_WIDTH_OFFSET = 24;
export const ENTITY_NAME_WIDTH_FIRST_ROW_OFFSET = 14;

export const MAX_USER_CHANGES = 10;

export const EDIT_ENTITY_ACTION = 'editEntityAction';
export const ADD_ENTITY_ACTION = 'addEntityAction';
export const DELETE_ENTITY_ACTION = 'deleteEntityAction';
export const DEFAULT_ACTION = 'defaultAction';
export const CUSTOM = 'CUSTOM';
export const PILGRIM = 'PILGRIM';
